import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';

import Select, { SelectItem } from '../ui/Select';
import { FmsUser } from '../fms.core/FmsUser';
import ApplicationContext from '../ApplicationContext';
import { ComboParamsBase, FmsComboType } from '../fms.core/constants';

function UsersDropDown({
  value,
  onChange = () => {},
  disabled = false,
  items = [],
  maxLength = undefined,
  name=undefined,
  selectId,
}: {
  value: string|null|undefined,
  disabled?: boolean,
  onChange?: (x:string|null) => void,
  items?: Array<FmsUser>,
  maxLength?: number|undefined,
  name?: string|undefined,
  selectId?: string,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<any>>([]);

  async function fetchData(api:any) {
    var base = new ComboParamsBase();
    base.comboType = FmsComboType.User;
    const data = await api.loadCodeData([base]);
    if (data && data.length > 0) {
      setData(data[0].items);
    }
  }

  function handleChange(e:React.ChangeEvent<HTMLInputElement>) {
    if (!e.target.value) {
      onChange(null);
      return;
    }
    
    const user = data.find(x => x === e.target.value);
    onChange(user ?? null);
  }

  useEffect(() => {
      if (items && items.length > 0) {
        setData(items);
      } else {
        fetchData(appContext.api);
      }
    
      return () => {
        setData([]);
      }
  },
   // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const displayData:Array<SelectItem> = [
    {value: '', label: '', activeLabel: '' },
    ...data.map(x => ({ value: x, label: x }))
  ];

  return (
    <Select
      selectId={selectId}
      name={name}
      maxLength={maxLength}
      value={(value === null || value === undefined) ? '' : value}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
    />
  );
}

UsersDropDown.defaultProps = {
  onChange: () => {},
  disabled: false,
  dark: false,
};

UsersDropDown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  items: PropTypes.array,
  selectId: PropTypes.string,
};

export default React.memo(UsersDropDown);
